<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span class="font-weight-bold">
        {{ metricas.fluxo_canais.titulo }}
      </span>

      <!-- Toggle -->
      <toggle-button
          class="float-right"
          v-if="show_toggle"
          @change="handleTipoGrafico"
          :value="quantitativo"
          :sync="true"
          :labels="{
          checked: 'Quantidades',
          unchecked: 'Valores',
        }"
          :color="{
          checked: '#7DCE94',
          unchecked: '#39f',
          disabled: '#CCCCCC',
        }"
          :width="100"
      />
    </div>

    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table border table-hover mb-0">
          <thead class="thead-light">
          <tr>
            <th class="col-3">Origem</th>
            <th class="col-3">Finalização</th>
            <th class="col-2 text-right">Quantidade</th>
            <th class="col-2 text-right" v-if="show_toggle">Valor</th>
            <th class="col-2 text-right">
              % na origem
              <small class="text-muted d-block">
                ({{ quantitativo ? 'base: quantidade' : 'base: valor' }})
              </small>
            </th>
          </tr>
          </thead>

          <tbody>
          <!-- loop por origem -->
          <template v-for="grupo in groupedRows">
            <!-- linha de título da origem -->
            <tr class="table-active">
              <td colspan="5" class="font-weight-bold">
                Origem: {{ grupo.origem }}
              </td>
            </tr>

            <!-- linhas da origem -->
            <tr v-for="row in grupo.linhas">
              <td>{{ row.inicio }}</td>
              <td>{{ row.fim }}</td>
              <td class="text-right">{{ formatNumber(row.qtd) }}</td>
              <td class="text-right" v-if="show_toggle">{{ formatCurrency(row.total) }}</td>
              <td>
                <div class="d-flex justify-content-between align-items-baseline">
                  <div class="fw-semibold">{{ row.percent.toFixed(2) }}%</div>
                </div>
                <div class="progress progress-thin" style="height: 5px;">
                  <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      :style="`width: ${row.percent}%; height: 5px;`"
                      aria-valuemin="0"
                      aria-valuemax="100"
                  ></div>
                </div>
              </td>
            </tr>
          </template>

          <tr v-if="groupedRows.length === 0">
            <td :colspan="show_toggle ? 5 : 4" class="text-center text-muted py-4">
              Nenhum dado para exibir.
            </td>
          </tr>
          </tbody>

          <tfoot>
          <tr class="thead-light">
            <th colspan="2">Totais gerais</th>
            <th class="text-right">{{ formatNumber(totalQtdGeral) }}</th>
            <th class="text-right" v-if="show_toggle">{{ formatCurrency(totalValorGeral) }}</th>
            <th></th>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FluxoCanaisTable",
  props: [
    "metricas",
    "colaborador"
  ],
  data () {
    return {
      // true = quantidade, false = valor
      quantitativo: true
    }
  },
  computed: {
    // pega o array de fluxo
    fluxos () {
      // se metricas vier undefined no começo, evita erro
      if (!this.metricas || !Array.isArray(this.metricas.fluxo_canais.metricas)) {
        return []
      }
      return this.metricas.fluxo_canais.metricas
    },
    // normaliza
    rows () {
      const base = Array.isArray(this.fluxos) ? this.fluxos : []
      return base.map((f, idx) => ({
        _id: idx,
        inicio: f.plataforma_inicial,
        fim: f.plataforma_final,
        qtd: Number(f.quantidade_pedidos) || 0,
        total: Number(f.valor_total_pedidos) || 0
      }))
    },
    // total geral (só pra footer)
    totalQtdGeral () {
      return this.rows.reduce((acc, r) => acc + r.qtd, 0)
    },
    totalValorGeral () {
      return this.rows.reduce((acc, r) => acc + r.total, 0)
    },
    // agrupa por origem e calcula % dentro da origem
    groupedRows() {
      // 1. agrupar por origem
      const grupos = {}
      this.rows.forEach(r => {
        if (!grupos[r.inicio]) {
          grupos[r.inicio] = []
        }
        grupos[r.inicio].push(r)
      })

      // 2. montar array final
      const resultado = Object.keys(grupos).map(origem => {
        const linhas = grupos[origem]
        // totais da origem (mudam com o toggle)
        const totalQtdOrigem = linhas.reduce((acc, r) => acc + r.qtd, 0)
        const totalValOrigem = linhas.reduce((acc, r) => acc + r.total, 0)

        const linhasComPercent = linhas.map(l => {
          let percent = 0
          if (this.quantitativo) {
            percent = totalQtdOrigem > 0 ? (l.qtd / totalQtdOrigem) * 100 : 0
          } else {
            percent = totalValOrigem > 0 ? (l.total / totalValOrigem) * 100 : 0
          }
          return {...l, percent}
        })

        // opcional: ordenar dentro da origem pelo maior %
        linhasComPercent.sort((a, b) => b.percent - a.percent)

        return {
          origem,
          linhas: linhasComPercent
        }
      })

      // opcional: ordenar origens alfabeticamente
      resultado.sort((a, b) => a.origem.localeCompare(b.origem))

      return resultado
    },
    show_toggle() {
      // se colaborador vier undefined, evita erro
      const tipo = this.colaborador && this.colaborador.tipo ? this.colaborador.tipo : ''
      return ['SUPERVISOR', 'ADMIN', 'GERENTE'].indexOf(tipo) >= 0;
    },
  },
  methods: {
    handleTipoGrafico(estado) {
      // vue-js-toggle-button passa { value: true/false }
      this.quantitativo = estado.value
    },
    formatNumber(n) {
      return Number(n).toLocaleString('pt-BR')
    },
    formatCurrency(n) {
      return 'R$ ' + Number(n).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }
  }
}
</script>
